import React from 'react';
import ResourceLibrary from '../resources/ResourceLibrary';

const MentorResources: React.FC = () => (
  <ResourceLibrary
    eyebrow="Mentor"
    lead="Material del programa para acompañar a tu mentee: guías de conversación, videos y plantillas listas para usar. Se actualiza a lo largo del año, así que vale la pena volver."
  />
);

export default MentorResources;
